prismanoteApp.directive('companyBlockRetailerPortal', function () {
  return {
    restrict: 'E',
    replace: 'true',
    templateUrl: '../views/directives/company-block-retailer-portal.html',
    scope: false
  }
})
